// 應用版本字串（操作手冊與系統資訊共用，單一真相）
//
// 📌 發版紀律（2026-08-07 起，見 repo 根目錄 CHANGELOG.md）：
//    功能新增或缺陷修復合併後 → 更新 SYSTEM_VERSION → 於 CHANGELOG.md 補一節
//    → 該 commit 打 git tag（例：v4.2.0），使「畫面顯示的版本」→「原始碼」可一鍵回溯。
//    ⚠️ v4.1.0(07-31) 之後曾累積 16 個 commit 未更新版本號（含線上故障修復），
//       任何人看「關於」頁都以為還是同一版 —— 故補上本紀律。
//    手冊版本(MANUAL_VERSION)只在手冊內容真的改版時才動，與系統版本各自獨立。
export const MANUAL_VERSION = 'v2.1.0';
// 2026-10-15 Frank：版號改制為 V1.xx.xx 兩位數格式（與美濃監控站、雲平台一致）；承 v4.4.5 之後從 V1.00.01 起算，
//    每次發版第三段 +1（滿 99 進第二段）；後端 app/version.py 同步（後端不帶 'V'）
export const SYSTEM_VERSION = 'V1.00.41';

// 建置戳記：由 scripts/build.js 於 build 時注入（git 短雜湊＋日期）。
// 開發模式（npm start）或無 git 時 fallback 'dev'，不影響顯示。
// 防禦性去掉可能殘留的 dirty 標記 '+'，UI 一律顯示乾淨短雜湊。
export const BUILD_SHA = (process.env.REACT_APP_GIT_SHA || 'dev').replace(/\+$/, '');
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '';
// 顯示用：日期為主、雜湊為輔（見 SystemPage / ManualContent 的「建置日期」列）。
